import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
    selector: 'app-checkbox-renderer',
    imports: [],
    templateUrl: './checkbox-renderer.component.html'
})
export class CheckboxRendererComponent implements ICellRendererAngularComp {
    value = signal<string | undefined>(undefined);

    agInit(params: ICellRendererParams<any, any, any>): void {
		this.refresh(params);
	}

	refresh(params: ICellRendererParams): boolean {
		this.value.set(params.value);
		return true;
	}
}
